import { useState, useEffect } from 'react'

// local imports
import FloorService from 'service/FloorService'
import { IAuthFloorListByLocation, Occupancy } from 'types/FloorType'

export default function useGetLocationsFloorList(locationId: number, occupancyDate: string) {
  const [floorList, setFloorList] = useState<IAuthFloorListByLocation[] | undefined>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  function fetchData() {
    setIsLoading(true)
    FloorService.getLocationsFloorListByLocation(locationId)
      .then((r) => {
        const floorList = r.data
        FloorService.getLocationFloorsOccupancy({
          id: locationId,
          occupancyDate: occupancyDate,
        })
          .then((r) => {
            const floorOcc = r.data
            const _floorList = floorList.map((floor) => {
              const matched = floorOcc.filter((fo: Occupancy) => fo.id === floor.id)
              const newData = { ...floor, Occupancy: matched[0] }
              return newData
            })
            setFloorList(_floorList)
          })
          .catch((err) => setError(true))
          .finally(() => setIsLoading(false))
      })
      .catch((err) => setError(true))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchData(), [])

  return { floorList, isLoading, error }
}
